<template>
  <div class="main card">
    <div class="add-line" @click="addLine">
      <img src="../../../assets/images/dadbanan/plus.svg" />
      <div>اضافه کردن سرفصل</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    addLine() {
      this.$emit('addline', true)
      this.$store.commit('headlines/SET_FILE_CARD', false)
      let query = Object.assign({}, this.$route.query)
      if (Object.keys(query).length) {
        delete query.id
        delete query.act
        delete query.new
        delete query.fileId
        this.$router.replace({ query })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.main {
  width: 100%;
  padding: 20px;
}

.add-line {
  border: 2px dashed #556ee6;
  border-radius: 5px;
  cursor: pointer;
  margin: auto;
  width: 100%;
  display: flex;
  justify-content: center;
  padding: 15px 0;

  div {
    font-weight: 700;
    font-size: 16px;
    color: #556ee6;
    margin-right: 17px;
  }
}
</style>
